import {
  GET_REQUEST, GET_SUCCESS,
  GET_FAILURE, TOGGLE_MENU, UPDATE_REQUEST, UPDATE_SUCCESS, UPDATE_FAILURE,
  CLEAR,
} from '../actions/customerView';
import {combineReducers} from 'redux';
import _ from 'lodash/fp';

const orderArchived = _.orderBy(['archived'], ['desc']);

const defaultState = {
  isFetching: false,
  order: null,
  project: null,
  apartment: null,
  error: null,
};

const order = (state = defaultState, action) => {
  switch (action.type) {
    case UPDATE_SUCCESS:
      return {
        ...state,
        order: action.order,
        isFetching: false,
        error: null,
      };
    case UPDATE_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case GET_REQUEST:
      return {
        ...state,
        isFetching: true,
        order: null,
        project: null,
        apartment: null,
        error: null,
      };
    case GET_SUCCESS:
      return {
        ...state,
        isFetching: false,
        order: action.order,
        project: action.project,
        apartment: {
          ...action.apartment,
          oldContracts: orderArchived(action.apartment.oldContracts),
          oldFloorPlans: orderArchived(action.apartment.oldFloorPlans),
          oldKitchenPlans: orderArchived(action.apartment.oldKitchenPlans),
        },
        error: null,
      };
    case GET_FAILURE:
    case UPDATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    case CLEAR:
      return defaultState;
    default:
      return state;
  }
};

const defaultMenuVisibility = false;

const menuVisibility = (state = defaultMenuVisibility, action) => {
  switch (action.type) {
    case TOGGLE_MENU:
      return !!action.show;
    case CLEAR:
      return defaultMenuVisibility;
    default:
      return state;
  }
};

const customerView = combineReducers({
  order,
  showMenu: menuVisibility,
});

export default customerView;



// WEBPACK FOOTER //
// ./src/reducers/customerView.js